import React from 'react';
import Button from '../../components/shared/Button/Button';
import StatusBadge from '../../components/shared/StatusBadge/StatusBadge';
import { StatusCard } from '../../components/promoters/promoters.styles';
import { promoterStatus, statusMessage } from '../../components/promoters/promoterLabels';

// Pantalla de un promotor que NO puede operar: pendiente de aprobación,
// rechazado o suspendido (code promoter_pending | promoter_rejected |
// promoter_suspended). Solo ve su estado, nada más.
const PromoterStatus = ({ promoter, onRefresh, refreshing }) => {
  const info = statusMessage(promoter);
  const state = promoterStatus(promoter.status);
  if (!info) return null;

  return (
    <StatusCard $tone={info.tone} role="status" aria-live="polite">
      <StatusBadge status={state.status}>{state.label}</StatusBadge>
      <h2>{info.title}</h2>
      <p>{info.body}</p>
      <div style={{ marginTop: 16 }}>
        <Button variant="secondary" onClick={onRefresh} disabled={refreshing}>
          {refreshing ? 'Actualizando…' : 'Actualizar estado'}
        </Button>
      </div>
    </StatusCard>
  );
};

export default PromoterStatus;
